'use strict';

module.exports = {
  position: true,
  gfm: true,
  commonmark: false,
  pedantic: false,
  blocks: require('./block-elements')
};